exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spot-detail[data-v-f3c5c264]{font-size:12px}.spot-detail-title[data-v-f3c5c264]{margin-bottom:10px}.spot-detail-title[data-v-f3c5c264] ons-col{flex:0 0 auto;width:auto}.spot-detail-title[data-v-f3c5c264] .select-input{margin-left:5px;font-size:inherit;color:inherit}.time-chart[data-v-f3c5c264]{width:100%}.swiper-pagination[data-v-f3c5c264]{position:relative;width:100%;text-align:center}.swiper-pagination[data-v-f3c5c264] .swiper-pagination-bullet{margin:0 3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3c5c264","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/map/destination/state/spot.vue
// module id = 596
// module chunks = 0